export default __webpack_public_path__ + "static/Twój_Styl_Twoja_Magia-8f70cd7168bd48202c19a363f7b99688.png";